import { Route, Switch, Redirect } from 'react-router-dom';
// import Home from 'pages/home';
import Login from 'pages/login';
import Dashboard from 'pages/dashboard';
import Courses from 'pages/Courses';
import ManageCourses from 'pages/Courses/ManageCourses';
import { AuthContext } from 'context/AuthContext';
import { useContext } from 'react';
import AdminLayout from 'pages/Layouts/Admin/AdminLayout';
import ListQuiz from 'pages/manage-quiz';
import ListNotification from 'pages/manage-notification';
import ManageNotification from 'pages/manage-notification/manage';
import ManageNotifications from 'pages/manage-notifications/manage';
import ListNotifications from 'pages/manage-notifications';
import ManageQuiz from 'pages/manage-quiz/manage';
import ListClass from 'pages/manage-class';
import ManageClass from 'pages/manage-class/manage';
import ListEST from 'pages/manage-est';
import ManageEST from 'pages/manage-est/manage';
import ListUsers from 'pages/manage-user';
import ManageRequests from 'pages/manage-requests';
import ManageUser from 'pages/manage-user/manage';
import { CMP } from 'context/CourseSubMenu';
import QuizQuestions from 'pages/manage-quiz/manage/Questions';
// import ManageQuestions from 'pages/manage-quiz/manage/Questions/manage';
import ManageQuestions from 'pages/manage-quiz/manage/Questions/manage/Main';
import MainSubjects from 'pages/manage-subjects';
import ManageSubjectPage from 'pages/manage-subjects/ManageSubjectPage';
import MainES from 'pages/manage-es';
import ManageESPage from 'pages/manage-es/ManageESPage';
import MainPlan from 'pages/manage-plan';
import MainCourseBundles from 'pages/manage-courses-bundles';
import MainChapters from 'pages/manage-chapters';
import MainTopics from 'pages/manage-topics';
// import MainTopicContents from 'pages/manage-topics/manage-contents';
import MainTopicContents from 'pages/manage-topics/manage-contents/main';
import ContentsPreview from 'pages/manage-topics/manage-contents/PreviewSection';
import MainSubjectPlans from 'pages/manage-class/manage-subject-plans';
import MainChaptersQuiz from 'pages/manage-chapters-quiz';

import Html from 'pages/html';
import Coursehtml from 'pages/html/courses.js';
import AddCourseInfohtml from 'pages/html/addcourseinfo.js';
import Notificationhtml from 'pages/html/notificationdashboard.js';
import CourseContenthtml from 'pages/html/coursecontent.js';
import AddCourseVideohtml from 'pages/html/addvideo.js';
import AddCourseStoryhtml from 'pages/html/addstory.js';
import Discoverhtml from 'pages/html/discover.js';
import MainAssessPerform from 'pages/manage-assess-perform';

import ForgotPassword from 'pages/forgot-password/Reset/adminResetPassword.js';
import UpdateProfile from 'pages/profile';
import ChangePassword from 'pages/change-password';
// import UserReviewLogs from 'pages/UserReviewLogs/index_previous';
// import ReviewItems from 'pages/ReviewItems/index_previous';
import UserActionCenter from 'pages/UserActionCenter';
import AdminCentre from 'pages/AdminCentre';
import TimeLine from 'pages/timeline';
import Htmll from 'pages/htmll';
import Html2 from 'pages/html2';
import Html3 from 'pages/html3';
import UserReviewCounter from 'pages/UserReviewLogs';
import IndividualReviewItem from 'pages/ReviewItems';
import Podcast from 'pages/manage-Podcast';

import CategoryList from 'pages/manage-Podcast/category/index.js';
import ManageCategory from 'pages/manage-Podcast/category/ManageCategory';
import PodcastList from 'pages/manage-Podcast/podcast/index';
import ManagePodcast from 'pages/manage-Podcast/podcast/ManagePodcastDetails';
import EpisodeList from 'pages/manage-Podcast/podcast/episode';
import ManageEpisode from 'pages/manage-Podcast/podcast/episode/ManageEpisode';
import PlayableList from 'pages/manage-Podcast/podcast/episode/playable';
import ManagePlayable from 'pages/manage-Podcast/podcast/episode/playable/ManagePlayable';
import PodcastAnalytics from 'pages/manage-Podcast/analytics';
import ReorderCategory from 'pages/manage-Podcast/category/reorderCategory';
import ReorderEpisode from 'pages/manage-Podcast/podcast/episode/reorderEpisode';
import ReorderPodcast from 'pages/manage-Podcast/podcast/reorderPodcast';
import ReorderPlayable from 'pages/manage-Podcast/podcast/episode/playable/ReorderPlayable';
import ExamInfoIndex from 'pages/manage-Podcast/exam-info/index';
import ExamTypeList from 'pages/manage-Podcast/exam-info/ExamTypeList';
import ManageExamType from 'pages/manage-Podcast/exam-info/ManageExamType';
import RequestsAndRatings from 'pages/manage-Podcast/requests-ratings/index';
import ManageDoubts from 'pages/manage-doubts';
import ManageAnswerDoubt from 'pages/manage-doubts/ManageDoubt';
import HelpCenter from 'pages/manage-support';
import ManageSupportCategory from 'pages/manage-support/ManageSupportCategory';
import ManageSupportTopic from 'pages/manage-support/Topics/ManageSupportTopics';
import SupportTopics from 'pages/manage-support/Topics';
import SupportTicket from 'pages/manage-supportTicket';
import ManageSupportTicket from 'pages/manage-supportTicket/ManageSupportTicket';
import PodcastSupportList from 'pages/manage-Podcast/support';
import PodcastSubscriptionList from 'pages/manage-Podcast/subscriptions';
import PodcastSubscriptionDetail from 'pages/manage-Podcast/subscriptions/SubscriptionDetail';
import ManagePodcastSupportTicket from 'pages/manage-Podcast/support/ManageSupport';
import Curriculum from 'pages/Curriculum';
import ManageStream from '../pages/manage-stream/ManageStream';
import ListStream from '../pages/manage-stream/ListStream';
import RefundListPage from 'pages/manage-refunds';
import RefundDetailPage from 'pages/manage-refunds/RefundDetail';
import LessonIssues from 'pages/manage-lesson-issues';
import IssueDetail from 'pages/manage-lesson-issues/IssueDetail';
import LessonFeedback from 'pages/manage-lesson-feedback';
import FeedbackDetail from 'pages/manage-lesson-feedback/FeedbackDetail';

function AuthenticatedAdminRoute({ children, customProps = {}, ...rest }) {
  const authContext = useContext(AuthContext);

  return (
    <Route {...rest}>
      {authContext.isAuthenticated() ? (
        <CMP>
          <AdminLayout customProps={customProps}>{children}</AdminLayout>
        </CMP>
      ) : (
        <Redirect to="/" />
      )}
    </Route>
  );
}

function AppRoutes() {
  return (
    <Switch>
      <Route path="/" exact>
        {/* <Home /> */}
        <Login />
      </Route>
      <Route path="/login" exact>
        <Login />
      </Route>
      <Route path="/forgotPassword" exact>
        <ForgotPassword />
      </Route>

      <AuthenticatedAdminRoute path="/admin-centre" exact>
        <AdminCentre />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/console" exact>
        <Dashboard />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/users/reviews" exact>
        <UserReviewCounter />
        {/* <UserReviewLogs /> */}
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/users/action_center" exact>
        <UserActionCenter />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/users/reviews/:reviewItem" exact>
        <IndividualReviewItem />
        {/* <ReviewItems /> */}
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/users/timeline" exact>
        <TimeLine />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/support/category" exact>
        <HelpCenter />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/courses" exact>
        <Courses />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/courses/add" exact>
        <ManageCourses />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute
        path="/courses/:courseID/edit"
        exact
        customProps={{ sideMenu: { showMenu: true, isInSights: true } }}
      >
        <ManageCourses editMode />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute
        path="/classes/:classID/courses/:courseID/chapters"
        exact
        customProps={{ sideMenu: { showMenu: true, showContentsSubMenu: true, isDiscover: true } }}
      >
        <MainChapters />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute
        path="/classes/:classID/courses/:courseID/assess"
        exact
        customProps={{ sideMenu: { showMenu: true, showContentsSubMenu: true, isAssess: true } }}
      >
        <MainAssessPerform pageType="assess" />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute
        path="/classes/:classID/courses/:courseID/perform"
        exact
        customProps={{ sideMenu: { showMenu: true, showContentsSubMenu: true, isPerform: true } }}
      >
        <MainAssessPerform pageType="perform" />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute
        path="/classes/:classID/courses/:courseID/chapters/:chapterID/topics/:topicID/contentPreview"
        exact
      >
        <ContentsPreview turnOnCommenting />
      </AuthenticatedAdminRoute>

      <AuthenticatedAdminRoute
        path="/classes/:classID/courses/:courseID/chapters/:chapterID/topics/:topicID/commentHistory"
        exact
      >
        <ContentsPreview forCommentHistory />
      </AuthenticatedAdminRoute>

      <AuthenticatedAdminRoute path="/classes/:classID/courses/:courseID/chapters/:chapterID/topics/:topicID">
        <MainTopicContents />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute
        path="/classes/:classID/courses/:courseID/chapters/quizzes"
        exact
        customProps={{ sideMenu: { showMenu: true, showContentsSubMenu: true, isDiscover: true } }}
      >
        <MainChaptersQuiz />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute
        path="/classes/:classID/courses/:courseID/chapters/:chapterID/quizzes/:quizID/questions"
        exact
        customProps={{ sideMenu: { showMenu: true, showContentsSubMenu: true, isAssess: true } }}
      >
        <QuizQuestions />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute
        path="/classes/:classID/courses/:courseID/chapters/:chapterID/quizzes/:quizID/questions/add"
        exact
        customProps={{ sideMenu: { showMenu: true, showContentsSubMenu: true, isAssess: true } }}
      >
        <ManageQuestions />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute
        path="/classes/:classID/courses/:courseID/chapters/:chapterID/quizzes/:quizID/questions/:questionID/edit"
        exact
        customProps={{ sideMenu: { showMenu: true, showContentsSubMenu: true, isAssess: true } }}
      >
        <ManageQuestions editMode />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute
        path="/classes/:classID/courses/:courseID/quizzes/:quizID/questions"
        exact
        customProps={{ sideMenu: { showMenu: true, showContentsSubMenu: true, isAssess: true } }}
      >
        <QuizQuestions />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute
        path="/classes/:classID/courses/:courseID/quizzes/:quizID/questions/add"
        exact
        customProps={{ sideMenu: { showMenu: true, showContentsSubMenu: true, isAssess: true } }}
      >
        <ManageQuestions />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute
        path="/classes/:classID/courses/:courseID/quizzes/:quizID/questions/:questionID/edit"
        exact
        customProps={{ sideMenu: { showMenu: true, showContentsSubMenu: true, isAssess: true } }}
      >
        <ManageQuestions editMode />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/plans" exact>
        <MainPlan />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/courses/bundles" exact>
        <MainCourseBundles />
      </AuthenticatedAdminRoute>

      <AuthenticatedAdminRoute path="/manage/requests" exact>
        <ManageRequests />
      </AuthenticatedAdminRoute>

      {/*  */}
      <AuthenticatedAdminRoute path="/manage/stream" exact>
        <ListStream />
      </AuthenticatedAdminRoute>

      <AuthenticatedAdminRoute path="/manage/stream/add" exact>
        <ManageStream />
      </AuthenticatedAdminRoute>

      <AuthenticatedAdminRoute path="/manage/stream/edit/:streamID" exact>
        <ManageStream />
      </AuthenticatedAdminRoute>

      <AuthenticatedAdminRoute path="/manage/est" exact>
        <ListEST />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/est/add" exact>
        <ManageEST />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/est/edit/:estID" exact>
        <ManageEST />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/classes" exact>
        <ListClass />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/classes/add" exact>
        <ManageClass />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/classes/edit/:classID" exact>
        <ManageClass />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/quiz" exact>
        <ListQuiz />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/users" exact>
        <ListUsers />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/users/add" exact>
        <ManageUser />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/users/edit/:userID" exact>
        <ManageUser />
      </AuthenticatedAdminRoute>

      <AuthenticatedAdminRoute path="/manage/quiz/add" exact>
        <ManageQuiz />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/topics/:topicID/quiz/:quizID/edit" exact>
        <ManageQuiz />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/topics/:topicID/quiz/:quizID/questions" exact>
        <QuizQuestions />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/topics/:topicID/quiz/:quizID/questions/add" exact>
        <ManageQuestions />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute
        path="/manage/topics/:topicID/quiz/:quizID/questions/:questionID/edit"
        exact
      >
        <ManageQuestions editMode />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/subjects" exact>
        <MainSubjects />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/subjects/add" exact>
        <ManageSubjectPage />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/subjects/edit/:subjectID" exact>
        <ManageSubjectPage />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/es" exact>
        <MainES />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/es/add" exact>
        <ManageESPage />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/es/edit/:esID" exact>
        <ManageESPage />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/notifications" exact>
        {/* <ListNotification /> */}
        <ListNotifications />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/notification/:notificationId" exact>
        {/* <ManageNotification /> */}
        <ManageNotifications />
      </AuthenticatedAdminRoute>
      {/* <AuthenticatedAdminRoute path="/manage/classes/:classID/chapters" exact>
        <MainChapters />
      </AuthenticatedAdminRoute> */}
      <AuthenticatedAdminRoute path="/manage/classes/:classID/subjects/:subjectID/chapters" exact>
        <MainChapters />
      </AuthenticatedAdminRoute>

      <AuthenticatedAdminRoute
        path="/manage/classes/:classID/subjects/:subjectID/chapters/:chapterID/topics"
        exact
      >
        <MainTopics />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute
        path="/manage/classes/:classID/subjects/:subjectID/chapters/:chapterID/topics/:topicID"
        exact
      >
        <MainTopicContents />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/classes/:classID/plans" exact>
        <MainSubjectPlans />
      </AuthenticatedAdminRoute>

      <AuthenticatedAdminRoute path="/html" exact>
        <Html />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/coursehtml" exact>
        <Coursehtml />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/addcourseinfohtml" exact>
        <AddCourseInfohtml />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/notificationhtml" exact>
        <Notificationhtml />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/coursecontenthtml" exact>
        <CourseContenthtml />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/addcoursevideohtml" exact>
        <AddCourseVideohtml />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/addcoursestoryhtml" exact>
        <AddCourseStoryhtml />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/discoverhtml" exact>
        <Discoverhtml />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/profile" exact>
        <UpdateProfile />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/changePassword" exact>
        <ChangePassword />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/htmll" exact>
        <Htmll />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/html2" exact>
        <Html2 />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/html3" exact>
        <Html3 />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast-subscriptions" exact>
        <PodcastSubscriptionList />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast-subscriptions/:subscriptionId" exact>
        <PodcastSubscriptionDetail />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast/analytics" exact>
        <PodcastAnalytics />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast/category/reorder" exact>
        <ReorderCategory />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast/:podcastId/episode/reorder" exact>
        <ReorderEpisode />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast/reorder" exact>
        <ReorderPodcast />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute
        path="/podcast/:podcastId/episodes/:episodeId/playables/reorder"
        exact
      >
        <ReorderPlayable />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast/category/:categoryId" exact>
        <ManageCategory />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast/category" exact>
        <CategoryList />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast/:podcastId/episode/:episodeId" exact>
        <ManageEpisode />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast/list" exact>
        <PodcastList />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/curriculum" exact>
        <Curriculum />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast/exam-info/:boardId/exam-types/:examTypeId" exact>
        <ManageExamType />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast/exam-info/:boardId/exam-types" exact>
        <ExamTypeList />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast/exam-info" exact>
        <ExamInfoIndex />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast/requests-ratings" exact>
        <RequestsAndRatings />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast/:podcastId" exact>
        <ManagePodcast />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast" exact>
        <Podcast />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast/:podcastId/episodes" exact>
        <EpisodeList />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/podcast/:podcastId/episode/:episodeId/playables" exact>
        <PlayableList />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute
        path="/podcast/:podcastId/episode/:episodeId/playable/:playableId"
        exact
      >
        <ManagePlayable />
      </AuthenticatedAdminRoute>

      <AuthenticatedAdminRoute path="/doubtclearance" exact>
        <ManageDoubts />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/doubtclearance/answer/:doubtId" exact>
        <ManageAnswerDoubt />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/support/category/:categoryId" exact>
        <ManageSupportCategory />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/support/category/:categoryId/topics" exact>
        <SupportTopics />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/support/category/:categoryId/topics/:topicId" exact>
        <ManageSupportTopic />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/support/ticket" exact>
        <SupportTicket />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/support/ticket/:ticketId" exact>
        <ManageSupportTicket />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/support/podcast" exact>
        <PodcastSupportList />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/support/podcast/:ticketId" exact>
        <ManagePodcastSupportTicket />
      </AuthenticatedAdminRoute>

      {/* ── Refund management ── */}
      <AuthenticatedAdminRoute path="/manage/refunds" exact>
        <RefundListPage />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/refunds/:refundId" exact>
        <RefundDetailPage />
      </AuthenticatedAdminRoute>

      {/* ── Lesson issues & feedback ── */}
      <AuthenticatedAdminRoute path="/manage/lesson-issues" exact>
        <LessonIssues />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/lesson-issues/:id" exact>
        <IssueDetail />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/lesson-feedback" exact>
        <LessonFeedback />
      </AuthenticatedAdminRoute>
      <AuthenticatedAdminRoute path="/manage/lesson-feedback/:id" exact>
        <FeedbackDetail />
      </AuthenticatedAdminRoute>

      <Route>
        <Login />
      </Route>
    </Switch>
  );
}

export default AppRoutes;
